import {ROLE_ADMIN} from '../../vuex/modules/auth/models/current-user';

const admin = async ({next, store}) => store.getters['auth/currentUser'].role === ROLE_ADMIN ? next() : next({name: 'index'});

export default admin;